module.exports = __webpack_public_path__ + "img/gyuszigumi5.b82eaa25.jpg";